// 该文件用于创建vuex中最核心的store
import Vue from "vue";
import Vuex from "vuex";
// 使用插件
Vue.use(Vuex)


const userMsg = {
    namespaced:true,
    actions:{
		
		
		/********* 测试  this.$store.dispatch修改数据 ********/
        odd_jia(conText,value){
            if(conText.state.sum % 2 !== 0){
                conText.commit('JIA',value)
            }
        },
        wait_jia(conText,value){
            setTimeout(() =>{
                conText.commit('JIA',value)
            },2000)
        },
    },
    mutations:{
		userInfoC(state,value){
			state.userInfo = value
		},
		tokenC(state,value){
			state.token = value
		},
		/********* 测试  this.$store.commit 修改数据 （最终修改） ********/
        JIA(state,value){
            state.sum += value
        },
        JIAN(state,value){
            state.sum -= value
        },
    },
    state:{
        token:'',
		userInfo:{},
		/********* 测试 ********/
		sum:0,
    },
    getters:{
		// 是否登录状态
        isLogin(state){
            return state.token?true:false
        },
    },
}


/********* 测试 ********/
const persionPosion = {
    namespaced:true,
    actions:{
        addW(conText,value){
            if(value.name.indexOf('王')===0){
                conText.commit('ADD_PERSON',value)
            }else{
                console.log('G')
            }
        },
    },
    mutations:{
        ADD_PERSON(state,value){
            state.Persons.unshift(value)
        },
    },
    state:{
        Persons:[
            {name:'张三',id:1}
        ],
    },
    getters:{
        Persons_sum(state){
            return state.Persons.length
        },
    }
}




// 创建vuex的Store
export default new Vuex.Store({
    modules:{
        userMsg,
        persionPosion,
    }
})
